import { Text } from "@mantine/core";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { PageLayout } from "../../../components/layout";
import { ColumnType, ITableRef, Table } from "../../../components/table";
import { Tag } from "../../../components/tags";
import RenderText from "../../../components/ui/render-text";

const sectorData = [
  { id: "information-sector", name: "Үндсэн ангилал", type: "BASIC", level: "1", description: "Үйл ажиллагааны ангилал - хамгийн ерөнхий" },
  { id: "sector", name: "Сектор", type: "SECTOR", level: "2", description: "Үндсэн ангилал дотроос задрах эдийн засгийн сектор" },
  { id: "sub-sector", name: "Дэд сектор", type: "SUB-SECTOR", level: "3", description: "Сектор дотроос задрах эдийн засгийн дэд сектор" },
];

export function Sector() {
  const ref = useRef<ITableRef>(null);
  const breadcrumb = useBreadcrumb();

  const columns = useHeader();

  return (
    <PageLayout title="Секторын лавлах" subTitle="Dehub бизнес платформын эдийн засгийн секторын бүртгэл" breadcrumb={breadcrumb}>
      <Table ref={ref} name="partner-management-user-static-sector-data.list" columns={columns} dataSource={sectorData} pagination={false} />
    </PageLayout>
  );
}

const useHeader = (): ColumnType<any>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return (
        <Link to={`/partner-management/sector/${String(record.type).toLowerCase()}`}>
          <Tag color="gray.5" name={record?.name} useHover />
        </Link>
      );
    },
  },
  {
    title: "Түвшин",
    sorter: true,
    dataIndex: "level",
    render: (record) => {
      return (
        <Text size="sm" fw={500} c="#44566C">
          {record?.level ?? "-"}
        </Text>
      );
    },
  },
  {
    title: "Тайлбар",
    sorter: true,
    dataIndex: "level",
    render: (record) => <RenderText text={record?.description ?? "-"} />,
  },
];

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Эхлэл",
  },
  {
    label: "Секторын лавлах жагсаалт",
  },
];
